import reducer from "./redcuer";
import actions from "./actions";
import * as selectors from "./selectors";

export const fetchDataReducer = reducer;
export const fetchDataActions = actions;
export const fetchDataSelectors = selectors;
